<footer id="footer">
  <div class="footer-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 footer-links">
          <h4>DART Transit Education Program</h4>
          <p>
            P.O. Box 660163 <br>
            Dallas, Texas 75266-7232<br>
            United States <br><br>
          </p>
        </div>
        <div class="col-lg-4 col-md-6 footer-links">
          <h4>Contact</h4>
          <p>
            <strong>Phone:</strong> 214-749-3494<br>
            <strong>Email:</strong> <a href="mailto:TransitEducation@DART.org"> TransitEducation@DART.org</a><br>
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>
